export default __webpack_public_path__ + "dbdf1abe79ceb65c7d97038ba604835c.pdf";